import { actions } from "@grandvisionhq/state";
import "../../../state/actions.js";
import { defaultState } from "./state.js";
import { updatePrescriptionValue, updatePrescriptionRecognitionValues, updateUploadReference, removeUploadReference, updatePrescriptionInfo } from "../../../configurations/state/configurations/actions.js";
const reducer = actions.reducer(
  defaultState,
  actions.on(updatePrescriptionValue, (s, { payload }) => ({
    ...s,
    [payload.side]: {
      ...s[payload.side],
      [payload.parameter]: payload.value
    }
  })),
  actions.on(updatePrescriptionRecognitionValues, (s, { payload }) => ({
    ...s,
    left: payload.left,
    right: payload.right
  })),
  actions.on(
    updateUploadReference,
    (s, { payload }) => ({
      ...s,
      uploadReferences: {
        ...s.uploadReferences || {},
        [payload.scope]: payload.uploadReference
      }
    })
  ),
  actions.on(removeUploadReference, (s, { payload }) => {
    const { [payload.scope]: _toBeRemoved, ...remainingScopes } = s.uploadReferences || {};
    return {
      ...s,
      uploadReferences: remainingScopes
    };
  }),
  /**
   * Changes the prescription expiry date for the given frameSku
   */
  actions.on(updatePrescriptionInfo, (s, { payload }) => {
    return {
      ...s,
      additionalInfo: payload.value
    };
  })
);
export {
  reducer
};
//# sourceMappingURL=reducer.js.map
